<template>
  <div>
    <ListaCompeticiones />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ListaCompeticiones from "@/components/Torneos/ListaCompeticiones.vue"; // @ is an alias to /src

export default Vue.extend({
  name: "TorneosView",
  components: {
    ListaCompeticiones,
  },
});
</script>
